module.exports = __webpack_public_path__ + "img/imagen-usuario.e839a98d.svg";